<template>
  <div class="d-flex flex-column gap-12 mb-6">
    <divcard>
      <div class="card-part pt-0">
        <div class="txt-head black--text mb-2">
          <span class="theme-color-one">ส่วนที่ 1 :</span> ข้อมูลทั่วไป
        </div>

        <!-- Form 1 -->
        <div>
          <div class="txt-head black--text mb-3">1. ชื่อโครงการ</div>
          <!-- Form 1 #line1 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                แผนงาน
                <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
              </div>
              <TextField
                  readonly
                  theme="3"
                  :value="masterData.plan_master?.plan_name_th"
              ></TextField>
            </div>
          </div>

          <!-- Form 1 #line2 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                ชื่อโครงการ (ภาษาไทย)
                <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
              </div>
              <TextField
                  theme="3"
                  :value="form.project_name_th"
                  @onChange="setFormField('project_name_th', $event)"
              ></TextField>
            </div>
          </div>

          <!-- Form 1 #line3 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                ชื่อโครงการ (ภาษาอังกฤษ)
                <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
              </div>
              <TextField
                  theme="3"
                  :value="form.project_name_en"
                  @onChange="setFormField('project_name_en', $event)"
              ></TextField>
            </div>
          </div>

          <!-- Form 1 #line4 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                อ้างอิง (Requirement Form)
              </div>
              <AutoBox
                  theme="3"
                  :items="masterData.requirement_forms"
                  :value="form.reference_reg"
                  @onChange="setFormField('reference_reg', $event)"
              ></AutoBox>
            </div>
          </div>

        </div>

      </div>
    </divcard>
  </div>
</template>

<script>
import TextField from "../../../components/input/TextField"
import SwitchInset from "../../../components/input/SwitchInset"
import AutoBox from "../../../components/input/AutoBox"
import { eventBus } from "../../../plugins/global-funcs"
import { mapState } from "vuex"

export default {
  name: "CFormGeneral",
  components: {
    TextField,
    SwitchInset,
    AutoBox
  },
  props: {
    masterData: {
      default: () => ({})
    },
    isSameId: {
      default: false
    }
  },
  data () {
    return {
      form: {}
    }
  },
  computed: {
    ...mapState({
      GeneralForm: state => state.CForm.GeneralForm
    })
  },
  created () {
    if (this.isSameId && !this.masterData.form_c) this.form = this.GeneralForm
    if (this.masterData.form_c) {
      this.form = {
        project_name_th: this.masterData.form_c.project_section_general_info?.project_name_th,
        project_name_en: this.masterData.form_c.project_section_general_info?.project_name_en
      }
    }
    eventBus.$on('cFormGeneral', () => {
      eventBus.$emit('cFormGeneralSend', this.form)
    })

    eventBus.$on('cFormSummary', () => {
      this.$store.commit('CForm/addSummaryData', {
        partOneForm: this.form
      })
    })
  },
  methods: {
    setFormField (field, val) {
      this.form[field] = val
      this.$forceUpdate()
    }
  }
}
</script>

<style scoped>

</style>